<mat-form-field class="w-full" appearance="fill">
  <mat-label>{{ data.name }}</mat-label>
  <mat-select [formControl]="dataUpcast" [multiple]="isMulti" (openedChange)="openedChange($event)">
    <mat-option [class.!hidden]="!searchMode">
      <red-select-search #searcher></red-select-search>
    </mat-option>
    <mat-select-trigger *ngIf="isMulti && haveSelectAll">
      {{ getSelectedDisplay() }}
    </mat-select-trigger>
    <app-select-check-all *ngIf="isMulti && haveSelectAll" [model]="dataUpcast" [values]="optionValues"> </app-select-check-all>
    <mat-option *ngFor="let option of options | filter: ['label']:searcher.value" [value]="option.value">{{ option.label }}</mat-option>
  </mat-select>
</mat-form-field>
